/**
 * PSV-1911 — touch-device detection, shared by the controller (virtual
 * joystick, chat button, long-press tooltips) and main.ts (extra
 * pointers). Coarse-pointer media query first (the modern signal);
 * the fallback for environments without matchMedia requires actual
 * touch points — bare `'ontouchstart' in window` is true in jsdom and
 * some desktop builds.
 */
export function isTouchDevice(): boolean {
  try {
    if (typeof window === 'undefined') return false;
    if (typeof window.matchMedia === 'function') {
      // Trust the primary-pointer signal exclusively: a touchscreen
      // laptop has ontouchstart too, but its primary pointer is fine —
      // hijacking its keyboard/mouse controls would be a regression.
      return window.matchMedia('(pointer: coarse)').matches;
    }
    return (
      'ontouchstart' in window &&
      typeof navigator !== 'undefined' &&
      (navigator.maxTouchPoints ?? 0) > 0
    );
  } catch {
    return false;
  }
}
